import './Trending.scss';
import {
  Grid,
  GridItem,
  Icons,
  PendingContent,
  Spinner,
  Tooltip,
} from 'plume-ui';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import FormattedMessage from '../../../../utils/components/FormattedMessage';
import {
  AdjustableComponent,
  useClasses,
} from '../../../../utils/hooks/useClasses';
import { AlarmLegend } from '../../renderers';
import TrendingChart from '../TrendingChart/TrendingChart';
import TrendingSunburst from '../TrendingSunburst/TrendingSunburst';
//Renderers and formatters
import { HealthSummaryGenericStyles } from '../../containers/HealthSummary';
// Data providers
import { activePartnerAtom } from '../../../../state';
import {
  useGetPartnerHealth,
  useGetTypicalHealth,
} from '../../services/healthcheckServices';
import { memo } from 'react';

type TrendingProps = {
  passedClasses: HealthSummaryGenericStyles;
};

type TrendingStyles = {} & HealthSummaryGenericStyles;

const Trending: AdjustableComponent<TrendingProps, TrendingStyles> = ({
  classes,
  passedClasses,
}) => {
  const { t } = useTranslation();

  /* ACTIVE PARTNER */
  const activePartner = useRecoilValue(activePartnerAtom);

  const styles = useClasses(
    {
      root: `Trending`,
      title: `${passedClasses.title} Trending__${
        passedClasses.title.split('HealthSummary__')[1]
      }`,
      menuRow: `${passedClasses.menuRow} Trending__${
        passedClasses.menuRow.split('HealthSummary__')[1]
      }`,
      summaryCell: `${passedClasses.summaryCell} Trending__${
        passedClasses.summaryCell.split('HealthSummary__')[1]
      }`,
    },
    classes,
  );

  /* Health Trend Chart  */
  const { typicalHealthArray, typicalHealthLoading } = useGetTypicalHealth();

  const { partnerHealthArray, partnerHealthLoading } = useGetPartnerHealth(
    activePartner?.id ? activePartner.id : '',
  );

  const renderSunbursts = () => {
    if (!activePartner) {
      return <> </>;
    }
    return (
      <TrendingSunburst partner={activePartner?.id ? activePartner.id : ''} />
    );
  };

  return (
    <div className={styles.root}>
      <Grid>
        <GridItem colSpan="6" tabletColSpan="12">
          <div className="HealthSummary__SummaryCell">
            <div className={styles.title}>
              <FormattedMessage id="healthSummary.healthScore.label" />
              <Tooltip
                position="below"
                alignment="left"
                label={t('healthSummary.healthScore.tooltipText')}
                overrideMaxCharacters
                openInPortal
              >
                <Icons.InfoIcon
                  width={15}
                  className="HealthSummary__InfoIcon"
                />
              </Tooltip>
            </div>
            <PendingContent
              loading={typicalHealthLoading && partnerHealthLoading}
              loader={Spinner}
            >
              <div className="Trending__BarChart__container">
                <TrendingChart
                  typicalData={typicalHealthArray}
                  partnerData={partnerHealthArray}
                />
              </div>
            </PendingContent>
          </div>
        </GridItem>
        <GridItem colSpan="6" tabletColSpan="12">
          <div className="HealthSummary__SummaryCell">
            <div className={styles.title}>
              <FormattedMessage id="healthSummary.breakdown.label" />
              <Tooltip
                position="below"
                alignment="right"
                label={t('healthSummary.breakdown.typNetworkInfoTooltip')}
                overrideMaxCharacters
                openInPortal
              >
                <Icons.InfoIcon
                  width={15}
                  className="HealthSummary__InfoIcon"
                />
              </Tooltip>
            </div>
            {renderSunbursts()}
            <div className="TrendingSunburst__AlarmLegend">
              <AlarmLegend />
            </div>
          </div>
        </GridItem>
      </Grid>
    </div>
  );
};

export default memo(Trending);
